"use client";
import React, { useState, useEffect } from 'react';
import Nabvar from '../Components/Navbar/Navbar'
import Demo from '../Pages/Demo/Demo' 
import { sistemaURL } from '../Components/url.js';
export default function IndexLayout() {

    const [images, setImages] = useState([]);//BANNERS
    const [infoEmpresa, setInfoEmpresa] = useState({});
    useEffect(() => {
        cargarBanners();
        cargarDatosEmpresa();
    }, []);
    const cargarBanners = () => {
        fetch(`${sistemaURL}web/getBanners`, {
            method: 'GET',
        }).then(response => response.json())
            .then(data => {
                setImages(data)
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
            });
    };
    const cargarDatosEmpresa = () => {
        fetch(`${sistemaURL}web/getEmpresaInfo`, {
            method: 'GET',
        }).then(response => response.json())
            .then(data => {
                setInfoEmpresa(data[0])
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
            });
    };

    return (
        <div className='section-bg-color'>
            <Nabvar banners={images} info={infoEmpresa} />
            <div className='espaciobg'>

            </div>
            <Demo info={infoEmpresa} />
            {/* <h3>Hola manolo</h3> */} 
        </div>
        // <div className='section-bg-color'>
        //     <h1>Hola armando</h1>
        // </div>
    );
}
